import React from 'react';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const DownloadButtons = ({ data, filename = "job_data" }) => {
  const exportPDF = () => {
    if (!data || data.length === 0) {
      alert("No data to export.");
      return;
    }

    const doc = new jsPDF();
    doc.text("Job Data", 14, 10);

    const columns = Object.keys(data[0]);
    const rows = data.map(row => columns.map(col => row[col]));

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 20,
    });

    doc.save(`${filename}.pdf`);
  };

  const buttonStyle = {
    backgroundColor: 'white',
    color: 'black',
    border: '1px solid black',
    padding: '4px 10px',
    fontSize: '14px',
    borderRadius: '4px'
  };

  return (
    <div className="d-flex gap-1">
      <CSVLink
        data={data}
        filename={`${filename}.csv`}
        className="btn btn-sm"
        style={buttonStyle}
      >
        CSV
      </CSVLink>

      {/* <button
        className="btn btn-sm"
        style={buttonStyle}
        onClick={exportPDF}
      >
        PDF
      </button> */}
    </div>
  );
};

export default DownloadButtons;